import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Breadcrumb, Anchor, Row, Col, Carousel, Tabs, Input, Modal, message } from "antd";
import { MinusOutlined, PlusOutlined, RightOutlined } from "@ant-design/icons";
import { baseIframeUrl, request } from "@/utils/request";
import moment from 'moment';
import "./index.less";
import Config from "@/config/config";
import date from '@/assets/date.png'
import clock from '@/assets/clock.png'
import seat from '@/assets/seat.png'
import save from '@/assets/save.png';
import transfer_address from '@/assets/transfer_address.png';
import save_f from '@/assets/save.png';
import { convertDateToTimestamp, formatTimestampToDate, getTimeAgo } from "@/utils/func";
import { getUser } from "@/utils";

const { Link } = Anchor;

export default function TransferDetail() {
    const navigate = useNavigate();
    const location = useLocation();
    // const detail = location.state || {};
    const searchParams = new URLSearchParams(location.search);
    const [detail, setDetail] = useState({});
    const [imgs, setImgs] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [subNum, setSubNum] = useState(1)
    const [mobile, setMobile] = useState('')
    const [isRaffle, setIsRaffle] = useState(false)
    const onAnchorChange = (e) => {
        console.log(e);
        console.log(detail);
    };
    const getIsRaffle = async () => {
        const response = await request.post('/goodseat_order/is_raffle', {
            "good_seat_id": searchParams.get("id")
        });
        setIsRaffle(response.data || false)
    }
    const fetchData = async () => {
        try {
            const response = await request.get('/goodseat/detail?id=' + searchParams.get("id") + "&platform=web");
            setDetail(response.data || {});
            setImgs(response.data.covers.split("||"))
        } catch (error) {
            console.error('Failed to fetch data:', error);
        }
    };
    const getItems = () => {
        if (detail.restaurant_id) {
            return [
                {
                    "key": "1",
                    label: '座位详情',
                },
                {
                    "key": "2",
                    label: '购买须知',
                },
                {
                    "key": "3",
                    label: '餐厅信息',
                },
            ]
        } else {
            return [
                {
                    "key": "1",
                    label: '座位详情',
                },
                {
                    "key": "2",
                    label: '购买须知',
                },
            ]
        }

    }

    const onChange = (key) => {
        console.log(key)
        document.getElementsByClassName('ant-anchor-link-title')[key - 1].click();
    }
    const commitJoin = () => {
        if (!JSON.parse(sessionStorage.getItem('user'))?.last_name||!JSON.parse(sessionStorage.getItem('user'))?.mobile||!JSON.parse(sessionStorage.getItem('user'))?.email) {
            navigate("/ImproveInfo?typ=2")
            return
        }
        // if (!mobile) {
        //     message.error('请输入手机号')
        //     return
        // }
        console.log(JSON.parse(sessionStorage.getItem('user'))?.mobile)
        request.post('goodseat_order/create', {
            good_seat_id: detail?.id,
            reservation_service_charge: detail?.subscription_price * 1,
            mobile: JSON.parse(sessionStorage.getItem('user'))?.mobile,
            meal_deposit: detail?.meal_deposit * 1,
            reservation_total_amount: detail?.subscription_price * 1 + detail?.meal_deposit * 1,
        }).then(r => {
            message.success('参与成功')
            setIsModalOpen(false)
            setTimeout(() => {
                navigate("/transferOrderDetail?id=" + r.data.id)
            }, 500)
        })
    }
    useEffect(() => {
        window.scrollTo(0, 0)
        fetchData();
        getIsRaffle()
    }, []);

    return (
        <div className="content-detail">
            <div className="detail-title">
                <div className="detail-title-box">
                    <Breadcrumb separator="">
                        {sessionStorage.getItem("mbx") === null && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'main' && <Breadcrumb.Item href="/">主页</Breadcrumb.Item>}
                        {sessionStorage.getItem("mbx") === 'transfer' && <Breadcrumb.Item href="/transfer">好位转让</Breadcrumb.Item>}
                        <Breadcrumb.Separator>
                            <RightOutlined />
                        </Breadcrumb.Separator>
                        <Breadcrumb.Item>好位详情</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
            <div className="detail-container-header">
                <div className="detail-container-box">
                    <div className="header-img">
                        <Carousel autoplay>
                            {imgs.length && imgs.map((item) => {
                                return (
                                    (<div className="header-img">
                                        <img src={Config.imgPrefix + item} width="100%" height="100%"
                                            style={{ objectFit: "cover" }} alt="" />
                                    </div>)
                                )
                            })}
                        </Carousel>

                    </div>
                    <div className="info-content">
                        <div className="title">{detail.name}</div>
                        <div className="seat-info">
                            <span className="feature">{detail.title}</span>
                            <span className="remaining">剩余位置：{detail?.reservation_number_confirm - detail?.buy_seats_amount}/{detail?.reservation_number_confirm}</span>
                            <span className="time"> <img src={date} alt="" className="icon" /> {getTimeAgo(detail?.created_at)}</span>
                        </div>
                        <div className="date"><img src={clock} alt="" className="icon" /><span>预订时间：{formatTimestampToDate(detail?.reservation_date_confirm, 'day')} {detail.reservation_time_confirm}</span></div>
                        {/* <div className="seats bor"><img src={seat} alt="" className="icon" /><span>2F靠窗位置A区12号桌</span></div> */}
                        <div className="price">
                            <div className="amount"><span style={{ fontSize: '12px' }}>￥</span>{detail?.subscription_price}</div>
                            <div className="desposit">押金 ￥{detail?.meal_deposit}/人</div>
                        </div>
                        {
                            !detail.raffle && <div className="sub-num">
                                <div className="sub-num-tit">预定数量</div>
                                <div className="step-num">
                                    <div className="reduce" onClick={() => {
                                        if (subNum > 1) { setSubNum(subNum - 1) }
                                    }}><MinusOutlined /></div>
                                    <div className="num">{subNum}</div>
                                    <div className="add" onClick={() => {
                                        if (subNum < (detail?.reservation_number_confirm - detail?.buy_seats_amount)) { setSubNum(subNum + 1) }
                                        else { message.error('座位不足！') }
                                    }}><PlusOutlined /></div>
                                </div>
                            </div>
                        }

                    </div>

                </div>
            </div>
            <div className="detail-box">
                <div className="content-tab-box" style={{ boxShadow: "none", paddingTop: "0" }}>
                    <div
                        className="content-tabs"
                        style={{
                            paddingLeft: "20px",
                            display: "none"
                        }}
                    >
                        <Anchor
                            affix={false}
                            direction="horizontal"
                            onChange={onAnchorChange}
                            offsetTop={120}
                        >
                            <Link
                                href="#package_desc"
                                title="座位详情"
                            />
                            <Link
                                href="#sub_desc"
                                title="购买须知"
                            />
                            <Link
                                href="#cancel_rule"
                                title="餐厅信息"
                            />
                        </Anchor>

                    </div>
                    <div className="detail-tabs">
                        <Tabs defaultActiveKey="1" items={getItems()} indicatorSize={200} onChange={onChange} size="large"
                            // renderTabBar={renderTabBar}
                            tabBarStyle={{
                                width: "100%",
                                fontSize: "16px",
                                color: '#666666',
                                borderBottom: "2px solid rgba(0,0,0,0.098)"
                            }}
                            tabBarGutter={10}
                        />
                    </div>
                    <div>
                        <div id="package_desc" className="seat bor">
                            <div className="seat-title">座位详情</div>
                            <div className="seat-content">
                                <div className="seat-desc" dangerouslySetInnerHTML={{ __html: detail?.text_description?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>') }}></div>
                                <div className="seat-address">
                                    <img src={transfer_address} alt="" className="icon" />
                                    <span>{detail?.restaurant_address}</span>
                                </div>
                            </div>
                        </div>

                        <div id="sub_desc" className="seat bor">
                            <div className="seat-title">购买须知</div>
                            <div className="seat-content" dangerouslySetInnerHTML={{ __html: detail?.shopping_notice?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>') }}>
                            </div>
                        </div>
                        {
                            detail?.restaurant_id && <div id="cancel_rule" className="seat" onClick={() => {
                                navigate('/detail?id=' + detail?.restaurant_id)
                            }}>
                                <div className="seat-title">餐厅信息</div>
                                <div className="canteent-moudle">
                                    <div className="canteent-content">
                                        <img src={Config.imgPrefix + detail?.restaurant_info?.cover?.[0]} alt="" className="cover" />
                                        <div>
                                            <div className="canteent-name">{detail?.restaurant_info?.name}</div>
                                            <div className="canteent-region">
                                                {
                                                    detail?.restaurant_info?.category_list?.map((v, i) => {
                                                        return <span>{v.name}{detail?.restaurant_info?.category_list?.length - 1 != i && <span>·</span>} </span>
                                                    })
                                                }
                                                <span style={{ marginLeft: '10px' }}>{detail?.restaurant_info?.category}{detail?.restaurant_info?.region}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <RightOutlined />
                                </div>
                            </div>
                        }

                    </div>



                </div>

            </div>

            <div className="tool-big-box">
                <div className="tool-box">
                    <div className="amount-box">
                        <span style={{ fontSize: '12px' }}>￥</span>{detail?.subscription_price * subNum}
                    </div>

                    <div className="subscription-box">
                        {
                            !!detail?.raffle ?
                                <>
                                    {
                                        detail?.raffle_status === 0 ? (
                                            <button style={{
                                                width: "160px",
                                                height: "48px",
                                                background: '#E0E0E2',
                                                border: 'none',
                                                color: '#FFFFFF',
                                                fontSize: '18px',
                                                borderRadius: '4px',
                                            }}>抽奖待开放</button>
                                        ) : detail?.raffle_status === 2 ? (
                                            <button style={{
                                                width: "160px",
                                                height: "48px",
                                                background: '#E0E0E2',
                                                border: 'none',
                                                color: '#FFFFFF',
                                                fontSize: '18px',
                                                borderRadius: '4px',
                                            }}>抽奖已结束</button>
                                        ) : !isRaffle ? (
                                            <button
                                                style={{
                                                    width: "160px",
                                                    height: "48px",
                                                    background: '#C59D60',
                                                    border: 'none',
                                                    color: '#FFFFFF',
                                                    fontSize: '18px',
                                                    borderRadius: '4px',
                                                }}
                                                onClick={() => {
                                                    if (!getUser()) {
                                                        navigate("/login")
                                                        return
                                                    }
                                                    setIsModalOpen(true)
                                                }}>
                                                参与抽奖
                                            </button>
                                        ) : (
                                            <button style={{
                                                width: "160px",
                                                height: "48px",
                                                background: '#E0E0E2',
                                                border: 'none',
                                                color: '#FFFFFF',
                                                fontSize: '18px',
                                                borderRadius: '4px',
                                            }}>您已参与抽奖</button>
                                        )
                                    }

                                </> : <>
                                    {
                                        detail?.buy_seats_amount === detail?.reservation_number_confirm ? (
                                            <button style={{
                                                width: "160px",
                                                height: "48px",
                                                background: '#E0E0E2',
                                                border: 'none',
                                                color: '#FFFFFF',
                                                fontSize: '18px',
                                                borderRadius: '4px',
                                            }}>已售罄</button>
                                        ) : <>{
                                            convertDateToTimestamp(`${formatTimestampToDate(detail?.reservation_date_confirm)} ${detail?.reservation_time_confirm}`) > Math.floor(new Date().getTime() / 1000)
                                                ? (
                                                    <button style={{
                                                        width: "160px",
                                                        height: "48px",
                                                        background: '#C59D60',
                                                        border: 'none',
                                                        color: '#FFFFFF',
                                                        fontSize: '18px',
                                                        borderRadius: '4px',
                                                    }} onClick={() => {
                                                        if (!getUser()) {
                                                            navigate("/login")
                                                            return
                                                        }
                                                        if (!JSON.parse(sessionStorage.getItem('user'))?.last_name||!JSON.parse(sessionStorage.getItem('user'))?.mobile||!JSON.parse(sessionStorage.getItem('user'))?.email) {
                                                            navigate("/ImproveInfo?typ=2")
                                                            return
                                                        }
                                                        navigate('/transferOrderCommit?id=' + detail.id + '&num=' + subNum)
                                                    }}>
                                                        立即预订
                                                    </button>
                                                ) : (
                                                    <button style={{
                                                        width: "160px",
                                                        height: "48px",
                                                        background: '#E0E0E2',
                                                        border: 'none',
                                                        color: '#FFFFFF',
                                                        fontSize: '18px',
                                                        borderRadius: '4px',
                                                    }}>已过期</button>
                                                )
                                        }</>
                                    }
                                </>
                        }
                    </div>
                </div>
            </div>
            <Modal title="抽奖活动" open={isModalOpen} cancelText="暂不参与" okText="立即参与" onCancel={() => { setIsModalOpen(false) }} onOk={commitJoin}>
                {/* <div className="raffle-tip">手机号仅用于发送中奖通知,请放心填写</div> */}
                {/* <Input
                    placeholder="请输入手机号码"
                    value={mobile}
                    onInput={(e) => {
                        const value = e.target.value.replace(/\D/g, '');
                        setMobile(value);
                    }}
                /> */}
                <div className="raffle-rule">
                    <div className="raffle-rule-tit">抽奖须知 <span style={{ color: '#EA0025' }}>(重要)</span></div>
                    <div className="raffle-rule-desc" dangerouslySetInnerHTML={{ __html: detail?.raffle_remark?.replace(/ /g, '&nbsp;').replace(/\n|↵/g, '<br/>') }}></div>
                </div>
            </Modal>
        </div>
    )
}
